import React, { FunctionComponent } from 'react';
import yageo_portal from '../../static/portals_image/yageo_portal.png';
import kemet_portal from '../../static/portals_image/kemet_portal.png';
import pulse_portal from '../../static/portals_image/pulse_portal.png';
import LogoLink from './LogoLink';
import { Box } from '@mui/material';
import { useResponsive } from '../../contexts/ResponsiveContext';
import { SalesAndResourcesDistributorPortalsContent } from '../../graphql/pimcore/modules/siteContent/types/SalesAndResourcesDistributorPortals';
import { toUrl } from '@/utils/convertImagePath';

interface PortalModel {
    mfg: string;
    image: string;
    href: string;
    mfgText: string;
}

interface Portals {
    contentTree: SalesAndResourcesDistributorPortalsContent;
}

const Portals: FunctionComponent<Portals> = ({ contentTree }) => {
    const { isScreenSm } = useResponsive();

    const PortalModels: PortalModel[] = [
        {
            mfg: 'YAGEO',
            image: toUrl(yageo_portal),
            href: contentTree.yageoPortal.linkUrl,
            mfgText: contentTree.yageoPortal.linkText,
        },
        {
            mfg: 'KEMET',
            image: toUrl(kemet_portal),
            href: contentTree.kemetPortal.linkUrl,
            mfgText: contentTree.kemetPortal.linkText,
        },
        {
            mfg: 'PULSE',
            image: toUrl(pulse_portal),
            href: contentTree.pulsePortal.linkUrl,
            mfgText: contentTree.pulsePortal.linkText,
        },
    ];
    return (
        <Box
            sx={{
                margin: '4rem 0 4rem 0',
                backgroundColor: 'white',
                width: '100%',
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '2rem',
                flexDirection: isScreenSm ? 'column' : 'row', // Change flex direction based on isScreenSm
            }}
        >
            {PortalModels.map((model) => (
                <LogoLink
                    key={model.mfg}
                    mfg={model.mfg}
                    image={model.image}
                    href={model.href}
                    mfgText={model.mfgText}
                />
            ))}
        </Box>
    );
};

export default Portals;
